import React from 'react';
import { Icon } from './Icon';
import { PropTypes } from 'prop-types';

import styles from './actionMenu/actionMenu.module.scss';

export const ActionMenu = (props) => {
  const {
    className = '',
    actions,
    close,
  } = props;

  return (
    <div className={`${styles.list} ${className}`}>
      {close &&
        <button className={styles.close} onClick={close}>
          <Icon name="More" />
        </button>
      }
      {actions && !!actions.length && actions.map(action => (
        <button
          key={action.label}
          className={styles.itemBtn}
          onClick={(e) => {
            e.stopPropagation();
            action.onClick();
            if (close) close();
          }}
        >
          <span className={styles.icon}>
            <Icon name={action.iconName} />
          </span>
          {action.label}
        </button>
      ))}
    </div>
  );
};

ActionMenu.propTypes = {
  className: PropTypes.string,
  actions: PropTypes.array,
  close: PropTypes.func,
};
